import { ICatalogState } from '@app/+catalog/store/model/catalog-state.model';
import {
  SET_CATALOG_PAGE_NUMBER,
  SET_CATALOG_NB_PAGES,
  SET_CATALOG_NB_PRODUCTS,
  APPLY_FILTER,
  TRACK_PRODUCT_CLICK,
  SET_MARKETING_FILTER,
  SET_DEAL
} from '@app/+catalog/store/actions';

export const catalogStateDefault: ICatalogState = {
  pageNumber: null,
  nbPages: null,
  nbProducts: null,
  filterItem: null,
  filterOptions: null,
  forceFirstPage: null,
  keyword: null,
  position: null,
  indexName: null,
  productId: null,
  marketingFilter: null,
  deal: null
};

export function reducer(state: ICatalogState = catalogStateDefault, { type, payload }) {
  switch (type) {
    case SET_CATALOG_PAGE_NUMBER:
      const { pageNumber } = payload;
      return { ...state, pageNumber };

    case SET_CATALOG_NB_PAGES:
      const { nbPages } = payload;
      return { ...state, nbPages };

    case SET_CATALOG_NB_PRODUCTS:
      const { nbProducts } = payload;
      return { ...state, nbProducts };

    case APPLY_FILTER:
      const { filterItem, filterOptions } = payload;
      return { ...state, filterItem, filterOptions };

    case TRACK_PRODUCT_CLICK:
      const { keyword, position, indexName, productId } = payload;
      return { ...state, keyword, position, indexName, productId };

    case SET_MARKETING_FILTER:
      return { ...state, marketingFilter: payload };

    case SET_DEAL:
      return { ...state, deal: payload };

    default:
      return state;
  }
}

export const getState = (state: ICatalogState) => state;
